import React, { useEffect } from 'react'
import Footer from "../../../components/User/Footer/Footer"
import Header from "../../../components/User/Header/Header"
function AirportToDoor() {

   useEffect(()=>{
  window.scrollTo(0,0)
    },[])

  return (
    <div className='page-wrapper'>
        <Header/>
          {/* Hero Section  */}
      <section
          class="call-to-action-one sp-four"
        //   style={{ backgroundImage: `url(${HomeBanner})` }}
        >
          <div class="container">
            <div class="sec-title-one white text-center">
              <h2>Airport to Door Excess Baggage Delivery</h2>
            </div>
          </div>
        </section>
    
   <section className="why-chooseus sp-four">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-md-12 col-sm-12">
                <div className="choose-left-content">
                  <div className="sec-title-one">
                    {/* <h5>Our Qualification</h5> */}
                    <h2>
                      <span>Travelling stress free</span>
                      <br /> is no more a dream
                    </h2>
                  </div>
                  <div className="text mt-45">
                    <p>
                    Off for a vacation or returning from one, you might just have too many luggage, well that is quite obvious. But lugging that entire luggage from the airport to your destination is the main issue that you might find yourself in. It might also happen that you have a tight itinerary planned for your travel so traveling to your hotel and then leaving for the first stop on your itinerary would not be a smart travel option as it would wear you out. So, why not use the airport to door luggage service which is provided by Carry My Baggage for the people of India traveling to abroad.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-md-12 col-sm-12">
                <div className="choose-right-area">
                  <figure>
                    <img
                      src={require("../../../images/resource/shoose-us-1.jpg")}
                      alt=""
                    />
                  </figure>
                </div>
              </div>

            </div>
            <div className="row">
              <div className="col-xl-12 col-md-12 col-sm-12">
                <div className="choose-left-content">
                  <div className="text mt-45">
                    <p>
                    Wondering what Carry My Baggage is all about? Well, it is a very travel friendly service as the service provider offers to deliver your luggage from the airport to your living destination so that you do not have to carry it and you can start off with your itinerary straight away without wasting any time at all. This is a unique service provided by Carry My Baggage in India. They are the pioneers of providing this service in India and they also have a dedicated team of workers who take the responsibility of safely delivering your belongings to the desired location.
                    </p>
                    <p>We offer airport to door baggage service along with other unique services which would make your travel easier than ever. It would also help you to travel light but at the same time pack heavy or simply the way you want. As a part of airport to door service Carry My baggage also adds airport to airport service which means you do not have to pay unreasonably high excess baggage charge if you are carrying extra baggage as we would carry it for you to your desired location at the minimal possible rate.</p>
                    <p>
                    Isn’t this one of the best services that the modern day travel plans providing you with? Well, the best thing about this service is that all you need to do is log on to our website and book the service with a few clicks online. Technology has made not only travelling easy rather it has also made carrying your luggage easy from one destination to the other.


                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer/>
    </div>
  )
}

export default AirportToDoor